import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useAccount } from 'wagmi';

import { makeLoanOffer } from '@/api/loans';
import { useMakeLoanRequest } from '@/hooks/loans/useMakeLoanRequest';
import { ILoanNFT } from '@/redux/loans/model';
import { IDesiredTerms } from 'types/loan';

interface IMakeBorrowRequestParams {
  id: string;
  contractAddress: ILoanNFT['token_address'];
  collection: Pick<ILoanNFT, 'name'>;
  imageUrl: ILoanNFT['normalized_metadata']['image'];
  name: string | undefined;
}

export const useMakeBorrowRequest = (nft: IMakeBorrowRequestParams | null, callBack?: () => void) => {
  const { makeLoanRequest } = useMakeLoanRequest();
  const { address } = useAccount();

  const makeBorrowRequest: SubmitHandler<
    IDesiredTerms & {
      termUnix?: number;
    }
  > = async (terms) => {
    try {
      if (!nft) return;
      const { apr, principal, repay, term, interestRate, exp, currency, ltv } = terms;
      const {
        id,
        contractAddress,
        collection: { name: collectionName },
        imageUrl,
        name,
      } = nft;
      const response = await makeLoanRequest({
        terms,
        tokenId: id,
        collectionAddress: contractAddress,
      });
      if (!response) return;
      const { nonce, signature, termUnix } = response;

      await makeLoanOffer({
        apr,
        currency,
        signature,
        principal,
        repay,
        term,
        tokenId: id,
        termUnix,
        nonce,
        owner: address,
        collectionName,
        collectionAddress: contractAddress,
        interestRate,
        collectionMarketplaceId: contractAddress,
        image: imageUrl,
        expDuration: exp,
        ltv,
        name,
      });

      callBack?.();

      toast.success('The loan request has been successfully created.');
    } catch (e: any) {
      if (e.code === 4001) {
        toast.error('Offer Canceled');
      } else {
        toast.error(e.toString());
      }
    }
  };

  return { makeBorrowRequest };
};
